import { Button } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useEvaluationStart } from '@/module/Evaluation/model/EvaluationQuery';

import { Id, useAppNotification } from '@feature/utils';

interface StartEvaluationButtonProps {
  evaluationId: Id;
  alreadyStarted: boolean;
}

export function StartEvaluationButton({ evaluationId, alreadyStarted }: StartEvaluationButtonProps) {
  const notification = useAppNotification();
  const { mutate, isPending } = useEvaluationStart(evaluationId);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClick = () => {
    mutate(undefined, {
      onSuccess: () =>
        navigate({ to: `/evaluation/$evaluationId/report/gather`, params: { evaluationId: String(evaluationId) } }),
      onError: notification.error,
    });
  };

  return (
    <Button
      loading={isPending}
      size="xs"
      onClick={onClick}
    >
      {t(alreadyStarted ? 'evaluation.continueReporting' : 'evaluation.startReporting')}
    </Button>
  );
}
